
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"19","cy":"19","r":"19","fill":"#2FB95E"}}),_c('path',{attrs:{"d":"M15.25 21.615a1.757 1.757 0 100 3.513 1.757 1.757 0 000-3.513zm0 2.52a.764.764 0 110-1.527.764.764 0 010 1.528zM24.516 21.615a1.757 1.757 0 100 3.513 1.757 1.757 0 000-3.513zm0 2.52a.764.764 0 110-1.527.764.764 0 010 1.528zM17.227 16.216a.45.45 0 01-.448.447h-6.177a.449.449 0 01-.448-.447v-.269c0-.246.202-.447.448-.447h6.177c.247 0 .448.2.448.447v.269z","fill":"#fff"}}),_c('path',{attrs:{"d":"M27.96 18.836c-.645-.167-1.014-.272-1.267-.761l-.846-1.713c-.253-.488-.91-.888-1.46-.888H23.23s-.156.003-.156-.154v-1.436c0-.557-.315-1.013-.985-1.013h-9.43c-.96 0-1.416.456-1.416 1.013v.9s0 .268.259.268h5.277c.494 0 .895.401.895.895v.269a.896.896 0 01-.895.895h-5.277s-.26-.022-.26.258v.31c0 .246.338.246.338.246h3.553c.493 0 .895.401.895.895v.269a.896.896 0 01-.895.895h-3.497s-.393-.007-.393.306v2.175c0 .557.455 1.013 1.012 1.013h.56c.126 0 .145-.07.145-.106a2.292 2.292 0 012.29-2.29 2.292 2.292 0 012.29 2.29c0 .035-.01.106.087.106h4.514c.089 0 .085-.076.085-.106a2.292 2.292 0 012.29-2.29 2.292 2.292 0 012.29 2.29c0 .035 0 .106.055.106H28c.55 0 1-.45 1-1v-1.902c0-1.6-.505-1.6-1.04-1.74zm-1.905-.089h-2.848c-.117 0-.133-.114-.133-.114V16.26s-.007-.09.144-.09h.813c.49 0 1.075.355 1.3.79l.753 1.524c.031.061.065.116.102.165.026.035-.018.098-.13.098z","fill":"#fff"}}),_c('path',{attrs:{"d":"M15.58 19.089a.449.449 0 01-.447.447H9.448A.449.449 0 019 19.09v-.269c0-.246.201-.447.448-.447h5.685c.246 0 .447.201.447.447v.269z","fill":"#fff"}})])
          )
        }
      }
    